import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { GetProductCategoryListDropDownSlice } from "../../../redux/features/ProductCategorySlice";
import {
  GetMetaDataByIdSlice,
  UpdateMetaDataSlice,
  clearSelectedMetaData, // 🔥 ADD THIS IN SLICE
} from "../../../redux/features/MetaDataManagementSlice";

import Editor from "../../../common/Editor/Editor";

const EditMetaCategory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { selectedMetaData, loading } = useSelector(
    (state) => state.MetaDataManagement
  );

  const [categoryList, setCategoryList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form, setForm] = useState({
    type: "CATEGORY",
    categoryId: "",
    title: "",
    description: "",
    keywords: "",
    content: "",
    status: "active",
  });

  /* =========================
     Fetch category dropdown
  ========================== */
  useEffect(() => {
    dispatch(GetProductCategoryListDropDownSlice()).then((res) => {
      setCategoryList(res?.payload?.data || []);
    });
  }, [dispatch]);

  /* =========================
     Fetch metadata by ID
  ========================== */
  useEffect(() => {
    if (id) {
      dispatch(clearSelectedMetaData()); // 🔥 clear old data
      dispatch(GetMetaDataByIdSlice(id));
    }
  }, [id, dispatch]);

  /* =========================
     Prefill form
  ========================== */
  useEffect(() => {
    if (selectedMetaData && selectedMetaData._id === id) {
      setForm({
        type: "CATEGORY",
        categoryId: selectedMetaData.categoryId?._id || "",
        title: selectedMetaData.title || "",
        description: selectedMetaData.description || "",
        keywords: selectedMetaData.keywords?.join(", ") || "",
        content: selectedMetaData.content || "",
        status: selectedMetaData.status || "active",
      });
    }
  }, [selectedMetaData, id]);

  /* =========================
     Cleanup on unmount
  ========================== */
  useEffect(() => {
    return () => {
      dispatch(clearSelectedMetaData());
    };
  }, [dispatch]);

  /* =========================
     Handlers
  ========================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!id) return;

    setIsSubmitting(true);

    await dispatch(
      UpdateMetaDataSlice({
        id,
        payload: {
          ...form,
          keywords: form.keywords
            .split(",")
            .map((k) => k.trim())
            .filter(Boolean),
        },
      })
    );

    setIsSubmitting(false);
    navigate("/MetadataManagement/CategoryMetaData");
  };

  /* =========================
     Loader
  ========================== */
  if (loading || !selectedMetaData) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  /* =========================
     UI
  ========================== */
  return (
    <div className="Small-Wrapper mt-4">
      {/* Category */}
      <div className="form-group">
        <label>Category</label>
        <select
          className="form-control"
          name="categoryId"
          value={form.categoryId}
          onChange={handleChange}
        >
          <option value="">Select Category</option>
          {categoryList.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.categoryName}
            </option>
          ))}
        </select>
      </div>

      {/* Title */}
      <div className="form-group">
        <label>Title</label>
        <input
          className="form-control"
          name="title"
          value={form.title}
          onChange={handleChange}
        />
      </div>

      {/* Description */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          className="form-control"
          name="description"
          value={form.description}
          onChange={handleChange}
        />
      </div>

      {/* Keywords */}
      <div className="form-group">
        <label>Keywords</label>
        <input
          className="form-control"
          name="keywords"
          value={form.keywords}
          onChange={handleChange}
        />
      </div>

      {/* Content */}
      <Editor
        setContentState={setForm}
        type="content"
        content={form.content}
        form={form}
      />

      <button
        className="Button mt-3"
        disabled={isSubmitting}
        onClick={handleSubmit}
      >
        {isSubmitting ? "Updating..." : "Update"}
      </button>
    </div>
  );
};

export default EditMetaCategory;
